import React from "react";

export default function Results() {
  return (
    <div className="min-h-screen bg-gray-950 text-white p-6">
      <h1 className="text-2xl font-bold mb-4">🏆 Resultados del Día</h1>
      <p className="text-gray-400 mb-6">Aquí se mostrarán los resultados de las 10 predicciones generadas por la IA.</p>

      <div className="bg-gray-800 p-4 rounded-xl shadow text-center">
        <p className="text-green-400">✅ Aciertos y ❌ Errores serán analizados aquí.</p>
      </div>
    </div>
  );
}
